/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../../../store/user";
import { SignOut, User } from "@phosphor-icons/react";
import UserPhoto from "../../../../UI/UserPhoto/UserPhoto";
import { getInitials } from "../../../../../utilities/utilities";

const HeaderUserMenu: FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <UserPhoto
            user={user}
            initials={getInitials(user.full_name)}
            width={"100%"}
            size="fs-3 m-auto"
            symbol={"symbol-40px p-1"}
          />

          <div className="d-flex flex-column ml-3">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {user.first_name} {user.last_name}
            </div>
            <span className="fw-400 text-muted text-hover-primary fs-7">
              {user.email && user.email.length > 20
                ? `${user.email.substring(0, 20)}...`
                : user.email}
            </span>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <Link to={"/profile"} className="menu-link px-3 text-dark">
          <User className="mr-2" /> O Meu Perfil
        </Link>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <a
          onClick={() => {
            dispatch(userActions.logout());
            localStorage.removeItem("token");
          }}
          className="menu-link px-3 text-dark"
        >
          <SignOut className="mr-2" /> Terminar sessão
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
